import { render, staticRenderFns } from "./V2BackBtn.vue?vue&type=template&id=7211a20b&scoped=true&"
import script from "./V2BackBtn.vue?vue&type=script&lang=js&"
export * from "./V2BackBtn.vue?vue&type=script&lang=js&"
import style0 from "./V2BackBtn.vue?vue&type=style&index=0&id=7211a20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211a20b",
  null
  
)

export default component.exports